// removed by extract-text-webpack-plugin
module.exports = {"Wrapper":"_11y0M","Left":"_3hp9d","Right":"_31qUG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CalendarSmall/CalendarSmall.scss
// module id = 724
// module chunks = 0